var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:{
    'code-editor': true,
    'has-focus': _vm.hasFocus,
    'is-dragging': _vm.dragging,
    'is-full-screen': _vm.fullScreen
  },style:(("height: " + _vm.height))},[_c('textarea',{ref:"textarea",staticClass:"code-editor-textarea"}),(_vm.allowFullScreen)?_c('span',{staticClass:"full-screen-toggle",attrs:{"title":_vm.$t('Toggle Full Screen Mode')},on:{"click":function($event){_vm.fullScreen = !_vm.fullScreen}}},[_c('i',{class:_vm.fullScreen ? 'el-icon-fa-compress' : 'el-icon-fa-expand'})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }